import React, { useState } from 'react';
import { X, Mail, AlertCircle } from 'lucide-react';
import { useHideNavOnModal } from '../hooks/useHideNavOnModal';

const EmailSetupModal = ({ isOpen, tempToken, onSuccess, onCancel, api }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Esconde nav quando modal está aberto
  useHideNavOnModal(isOpen);

  const handleSubmit = async () => {
    if (!email || !email.includes('@')) {
      setError('Digite um email válido');
      return;
    }

    try {
      setLoading(true);
      setError('');
      const response = await api.post('/api/auth/email/setup', 
        { email }, 
        { params: { temp_token: tempToken } }
      );
      onSuccess(response.data);
    } catch (error) {
      setError(error.response?.data?.detail || 'Erro ao configurar email');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50 backdrop-blur-sm modal-anim">
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl max-w-md w-full shadow-2xl overflow-hidden border-2 border-gray-700">
        {/* Header */}
        <div className="relative bg-gradient-to-br from-blue-600 via-indigo-600 to-blue-600 px-8 py-6">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-400/20 to-indigo-400/20"></div>
          <div className="relative text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
              <Mail size={32} className="text-white" strokeWidth={2.5} />
            </div>
            <h2 className="text-2xl font-black text-white mb-1">
              Configure seu Email
            </h2>
            <p className="text-blue-100 text-sm font-medium">Necessário para verificação de segurança</p>
          </div>
        </div>

        <div className="p-8 space-y-6">
          {/* Info */}
          <div className="bg-blue-900/30 border border-blue-700 rounded-xl p-4">
            <p className="text-sm text-blue-200 text-center">
              Por segurança, precisamos do seu email para enviar códigos de verificação em cada login.
            </p>
          </div>

          {/* Email Input */}
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-bold text-gray-300 mb-3">
                Digite seu email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError('');
                }}
                placeholder="seu-email@exemplo.com"
                className="w-full p-4 bg-gray-800 text-white border-2 border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                autoFocus
              />
            </div>

            {error && (
              <div className="flex items-center gap-2 text-red-400 text-sm font-semibold bg-red-900/30 px-4 py-3 rounded-lg border border-red-700">
                <AlertCircle size={16} />
                {error}
              </div>
            )}
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-6 py-4 bg-gray-700 text-gray-200 rounded-xl hover:bg-gray-600 transition-all font-bold"
            >
              Cancelar
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading || !email}
              className="flex-1 px-6 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all font-bold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            >
              {loading ? 'Enviando...' : 'Continuar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSetupModal;
